import React from "react";
import { RaisedButton, CircularProgress } from "material-ui";
import { Link } from "react-router";
import Helmet from "react-helmet";
import pickBy from "lodash/pickBy";

import { formatInsertables, isApp } from "../util";
import PassList from "./partials/pass-list/pass-list.jsx";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../stores/PersonStore";
import PassStore from "../stores/PassStore";
import PassActions from "../actions/PassActions";

@connectToStores
class Memberships extends React.Component {
  static getStores() {
    return [PersonStore, PassStore];
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  static getPropsFromStores() {
    var props = PassStore.getState();
    props.getMembershipsForCurrentEventBucket =
      PassStore.getMembershipsForCurrentEventBucket;
    props.isLoggedIn = PersonStore.getState().isLoggedIn;
    return props;
  }

  static componentDidConnect(props, context) {
    // Don't redirect if pass query string is passed, since this means accept-pass-transfer is open.
    // Let accept-pass-transfer handle the redirection instead.
    if (!PersonStore.isLoggedIn() && !props.location.query.pass) {
      context.router.replace({
        pathname: "/login",
        query: { next: `/${context.tenant.passes_url_pathname}` },
        state: { noBack: props.location.query.from_email }
      });
    }
  }

  componentDidMount() {
    PassActions.fetchAll();
  }

  componentWillReceiveProps(newProps) {
    // On login, fetch all passes - triggered on login from accept-transfer modal
    if (newProps.isLoggedIn !== this.props.isLoggedIn) {
      PassActions.fetchAll.defer();
    }
  }

  getStyles() {
    return {
      container: {
        padding: 10
      },
      intro: {
        padding: 15,
        fontSize: "12pt",
        lineHeight: 1.5,
        color: "rgba(0,0,0,0.54)"
      },
      noPasses: {
        padding: "30px 10px",
        textAlign: "center"
      }
    };
  }

  render() {
    const styles = this.getStyles();

    let passes = this.props.getMembershipsForCurrentEventBucket();
    passes = pickBy(passes, p => !p.hidden_in_list);

    // Only show error stuff if we're not mocking for the admin interface
    if (!this.context.appSettings.mock_logged_in) {
      if (!this.props.hasUpdatedAll) {
        return (
          <div
            className="Eventive--MyPassesPage Eventive--passes Eventive--passes--loading"
            id="membership"
            style={styles.noPasses}
          >
            <Helmet title={`My ${this.context.tenant.display_memberships}`} />
            {this.props.children
              ? React.cloneElement(this.props.children, {
                  appSettings: this.props.appSettings
                })
              : undefined}
            <CircularProgress
              mode="indeterminate"
              size={119}
              thickness={7}
              style={{ margin: 10.5 }}
            />
          </div>
        );
      } else if (!passes || Object.keys(passes).length === 0) {
        return (
          <div
            className="Eventive--MyPassesPage Eventive--MyMembershipsPage Eventive--passes Eventive--passes--noPasses"
            style={styles.noPasses}
          >
            <Helmet title={`My ${this.context.tenant.display_memberships}`} />
            {this.props.children
              ? React.cloneElement(this.props.children, {
                  appSettings: this.props.appSettings
                })
              : undefined}
            <div style={{ fontSize: "11pt", marginBottom: 10 }}>
              {this.context.tenant.my_memberships_no_memberships
              ? formatInsertables(
                this.context.tenant.my_memberships_no_memberships.replace(
                  /\n/g,
                  "{{newline}}" 
                ),
                {
                  newline: () => <br />,
                  memberships: () => this.context.tenant.display_memberships,
                  buy_membership_link: t => (
                    <Link
                      key="buy_membership_link"
                      to={`/${this.context.tenant.memberships_url_pathname}/buy`}
                    >
                      {t}
                    </Link>
                  )
                }
              ) : null}
            </div>
            {!isApp() ? (<RaisedButton
              primary={true}
              label={`Learn more about ${this.context.tenant.display_memberships}`}
              onClick={() =>
                this.context.router.push(
                  `/${this.context.tenant.memberships_url_pathname}/buy`
                )
              }
            />) : null}
          </div>
        );
      }
    }

    return (
      <div
        className="Eventive--MyPassesPage Eventive--MyMembershipsPage Eventive--passes Eventive--passes--hasPasses"
        style={styles.container}
      >
        <Helmet title={`My ${this.context.tenant.display_memberships}`} />
        {this.props.children
          ? React.cloneElement(this.props.children, {
              appSettings: this.props.appSettings
            })
          : undefined}
        <div style={styles.intro}>
          {this.context.tenant.my_memberships_description
            ? formatInsertables(
                this.context.tenant.my_memberships_description.replace(
                  /\n/g,
                  "{{newline}}"
                ),
                {
                  newline: () => <br />,
                  buy_membership_link: t => (
                    <Link
                      key="buy_membership_link"
                      to={`/${this.context.tenant.memberships_url_pathname}/buy`}
                    >
                      {t}
                    </Link>
                  ),
                  schedule_link: t => (
                    <Link key="schedule_link" to="/schedule">
                      {t}
                    </Link>
                  ),
                  my_tickets_link: t => (
                    <Link key="/tickets" to="/tickets">
                      {t === '"My Tickets"' ? (
                        <span>"My&nbsp;Tickets"</span>
                      ) : (
                        t
                      )}
                    </Link>
                  ),
                  link: (href, label) => (
                    <a href={href} target="_blank">
                      {label}
                    </a>
                  )
                }
              )
            : null}
        </div>
        <PassList passes={passes} />
        {this.context.tenant.my_memberships_footer &&
        this.context.tenant.my_memberships_footer.__html ? (
          <InjectedTenantHTML
            style={{ marginTop: 10, ...styles.intro }}
            content={this.context.tenant.my_memberships_footer}
          />
        ) : null}
      </div>
    );
  }
}

export default Memberships;



// WEBPACK FOOTER //
// ./src/app/components/memberships.jsx